import { MobileUserCtrl }   from './user.mobile.ajs';
import { MobileUsersCtrl }  from './users.mobile-users';
import { UsersCtrl }        from './users';
import { UserSettingsCtrl } from './user.settings.ajs';
import { UsersStates }      from './users.states.ajs';

angular.module('workshop.users', [])
.controller('MobileUserCtrl',    MobileUserCtrl)
.controller('MobileUsersCtrl',   MobileUsersCtrl)
.controller('UsersCtrl',         UsersCtrl)
.controller('UserSettingsCtrl',  UserSettingsCtrl)
.config(UsersStates);